import mapValues from 'lodash/mapValues'
import omit from 'lodash/omit'

import { CustomerAddressType } from '@/hooks/customerAddressForm/useCustomerAddressForm'

export const transformAddressApiPayload = (
  values: CustomerAddressType & { country_id?: string },
) => {
  return {
    ...mapValues(omit(values, ['country_code', 'region', 'region_id']), (value) =>
      value === undefined ? '' : value,
    ),
    region: {
      region_id: Number(values.region_id) ?? 0,
      region: values.region ?? '',
    },
    country_id: values.country_code ?? values.country_id ?? '',
    default_shipping: values?.default_shipping === undefined ? false : values?.default_shipping,
    default_billing: values?.default_billing === undefined ? false : values?.default_billing,
  }
}
